export default function IsBase64(str) {
    try {
        return btoa(atob(str)) == str;
    } catch (e) {
        return false;
    }
}
